import api from "./core";

const basePath = "api/core/DoctorOrder";

export default {
  getFromDocument(documentId) {
    return api.get(`${basePath}/FromDocument/${documentId}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
